import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { DisbursementSummaryResponse } from "./getDisbursementSummary";

interface DisbursementSummaryRequest {
  token: string;
  noteId: number;
}

const bulkDisburseDistributorFunds = async ({
  token,
  noteId,
}: DisbursementSummaryRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-disbursement/bulk-disburse-distributor-funds`,
      { noteId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default bulkDisburseDistributorFunds;
